import { combineReducers, persistReducer, sessionStorage } from '@grandvisionhq/state';
import './bundles/selectors.js';
import { reducer } from './bundles/reducer.js';
import './configurations/selectors.js';
import { reducer as reducer$1 } from './configurations/reducer.js';
import './configurator/selectors.js';
import { reducer as reducer$4 } from './configurator/reducer.js';
import './prescription/state.js';
import { reducer as reducer$2 } from './prescription/reducer.js';
import './products/selectors.js';
import { reducer as reducer$3 } from './products/reducer.js';

const getConfig = (key)=>({
        storage: sessionStorage,
        key
    })
;
var prescriptionGlassesReducer = combineReducers({
    bundles: reducer,
    configurations: persistReducer(getConfig('grandvision_pg_configurations'), reducer$1),
    prescription: persistReducer(getConfig('grandvision_pg_prescription'), reducer$2),
    products: reducer$3,
    configurator: reducer$4
});

export { prescriptionGlassesReducer as default, getConfig };
//# sourceMappingURL=reducer.js.map
